

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AssessmentList extends Vue {
  @Prop() private options!: any;
  @Prop() private selectedOption!: number;

  private gotoNext() {
    this.$emit("gotoNext");
  }

  private onSelectOption(option: number) {
    this.$emit("onSelectedOption", option);
  }
}
